import { generateCorrelationId as generateBrowserCorrelationId } from '@soteria/logger/browser';

/**
 * Generates a unique correlation ID for Apollo-BFF request tracing
 * Simplified implementation focused on GraphQL operations only
 */
export function generateCorrelationId(): string {
  return generateBrowserCorrelationId();
}
